/**
 * Returns a similarity score label and color based on the provided similarity value.
 *
 * Uses conditional checks to determine the appropriate score and color based on
 * specific similarity thresholds:
 * - High: >= 90%
 * - Medium: 75-89%
 * - Low: 50-74%
 * - Below 50%: No score
 *
 * @param {number} similarity - The similarity percentage (0-100).
 * @returns {{score: string|undefined, color: string}}
 *   An object containing:
 *     - score: One of "High", "Medium", "Low", or undefined if below threshold.
 *     - color: A string representing the associated color class ("bg-green-bright",
 *             "bg-blue-bright", "bg-gray-500"), or "hidden" if below a threshold.
 *
 * @example
 * getSimilarityScore(92); // { score: "High", color: "bg-green-bright" }
 * getSimilarityScore(80); // { score: "Medium", color: "bg-blue-bright" }
 * getSimilarityScore(60); // { score: "Low", color: "bg-gray-500" }
 * getSimilarityScore(30); // { score: undefined, color: "hidden" }
 */
export const getSimilarityScore = (similarity) => {
  const result = { score: "", color: "hidden" };

  if (similarity >= 90) {
    result.score = "High";
    result.color = "bg-green-bright";
  }

  if (similarity >= 75 && similarity < 90) {
    result.score = "Medium";
    result.color = "bg-blue-bright";
  }

  if (similarity >= 50 && similarity < 75) {
    result.score = "Low";
    result.color = "bg-gray-500";
  }

  return result;
};
